export const APPROVAL_TABS = {
  PENDING: "pending",
  APPROVED: "approved",
};

export const UNLOCK_REASON_MAX_LENGTH = 500;

const readStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user")) || {};
  } catch (error) {
    return {};
  }
};

// แค่ใช้ซ่อน/แสดง tab เท่านั้น ส่วน scope ของข้อมูล backend เป็นคนกรอง
export const canViewApprovedTimesheets = (user = readStoredUser()) =>
  user?.role === "admin" || Number(user?.level || 0) >= 3;

export const resolveApprovalTab = (requestedTab, canViewApproved) =>
  requestedTab === APPROVAL_TABS.APPROVED && canViewApproved
    ? APPROVAL_TABS.APPROVED
    : APPROVAL_TABS.PENDING;

// วันที่วันนี้ตามเวลา Asia/Bangkok ในรูปแบบ YYYY-MM-DD
export const getBangkokDateKey = (now = new Date()) => {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Bangkok",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const pick = (type) => parts.find((part) => part.type === type)?.value;
  return `${pick("year")}-${pick("month")}-${pick("day")}`;
};

export const validateUnlockForm = ({ reason = "", reopenUntil = "" }, today = getBangkokDateKey()) => {
  const errors = {};
  const trimmedReason = reason.trim();

  if (!trimmedReason) {
    errors.reason = "กรุณาระบุเหตุผลการปลดล็อก";
  } else if (trimmedReason.length > UNLOCK_REASON_MAX_LENGTH) {
    errors.reason = `เหตุผลต้องไม่เกิน ${UNLOCK_REASON_MAX_LENGTH} ตัวอักษร`;
  }

  if (reopenUntil && reopenUntil < today) {
    errors.reopenUntil = "ห้ามเลือกวันที่ก่อนวันนี้";
  }

  return errors;
};

// backend อาจตอบ 400 พร้อม field ที่ผิด ให้ map เข้าช่องที่ตรงกัน
export const mapUnlockFieldErrors = (responseData = {}) => {
  const message = responseData?.message || "ข้อมูลไม่ถูกต้อง";
  const field = responseData?.field || responseData?.errors?.[0]?.field;
  const fieldErrors = responseData?.errors && !Array.isArray(responseData.errors)
    ? responseData.errors
    : null;

  if (fieldErrors) {
    return {
      ...(fieldErrors.reason ? { reason: String(fieldErrors.reason) } : {}),
      ...(fieldErrors.reopenUntil ? { reopenUntil: String(fieldErrors.reopenUntil) } : {}),
    };
  }

  if (field === "reopenUntil" || /reopenUntil|วันที่/i.test(message)) {
    return { reopenUntil: message };
  }

  return { reason: message };
};
